import { staticListHeaderStyles } from "@insite/content-library/Widgets/StaticList/StaticListHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { css } from "styled-components";

staticListHeaderStyles.saveListButton = {
    mergeCss: true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(
                theme,
                [
                    null,
                    css`
                        width: 100%;
                    `,
                ],
                "max",
            )}
    `,
};

staticListHeaderStyles.saveButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
};

staticListHeaderStyles.addListToCartButton = {
    mergeCss: true,
    css: css`
        width: 100%;
        padding: 0px 10px;
    `,
};
